const padding = 200
const intervalTime = 1000
const min = intervalTime - padding
const max = intervalTime + padding

let stack = []
let preClickTimestamp = 0
export const rhythmicClick = () => {
  const diff = getNowTime() - preClickTimestamp
  preClickTimestamp = getNowTime()

  if (diff > min && diff < max) {
    stack.push(true)
  } else {
    stack = []
  }

  if (stack.length === 5) {
    doAction()
  }
}

// 분리?
export const showCredit = ref(false)

const getNowTime = () => +new Date()

const doAction = () => {
  // show credit
  showCredit.value = true
  // const timeoutId = setTimeout(() => {
  //   showCredit.value = false
  // clearTimeout(timeoutId)
  // }, 5000)
}
